import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { API, errMsg } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  return (
    <div className="min-h-screen grid place-items-center px-6 relative z-10">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl bg-[#0F131D] border border-white/10 p-8 space-y-4" data-testid="admin-login-form">
        <h1 className="font-display font-bold text-2xl">Admin</h1>
        <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" data-testid="admin-email-input" className="h-12 bg-[#07090E]" />
        <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" data-testid="admin-password-input" className="h-12 bg-[#07090E]" />
        <button type="submit" data-testid="admin-login-button" className="w-full h-12 rounded-full bg-emerald-500 hover:bg-emerald-400 text-[#07090E] font-bold transition-colors">Sign in</button>
      </form>
    </div>
  );
}
